import brandLogo from '@/images/HQ Logos/HQLogoLGWhiteText.png';

export const brandName = '[BRAND]';
const brandCoin = 'IZE';
export const staticSite = 'https://dev.nerdunited.net/';

export const brand = {
  // Brand Info
  brandName,
  coin: brandCoin,
  loggedOutHomeRoute: '/', //clicking 'home' like the brand logo - where do you want to take the user, you can also put your static site url here
  loggedInHomeRoute: '/admin-portal',
  authenticationLogo: brandLogo.src,
  errorMessages: {
    genericError: 'Something has gone wrong, please try again later.',
    inputValidationFields: {
      name: 'Improperly formatted name',
      email: 'Enter a valid email (john@example.com)',
      password: 'Password does not meet the character requirement',
      confirmPassword: 'Passwords do not match',
      checkbox: 'You must be over 18 to sign up.',
      phone: 'Improperly formatted phone number',
    },
    birthDateError: 'Invalid Date Format, please use MM/DD/YYYY',
    birthDateAge: 'Please check the year',
  },
};
